import { DEVICE_GROUP_SEARCH } from './action_types';

const search = payload => ({
  type: DEVICE_GROUP_SEARCH,
  payload: payload
});

export { search };
